import axios from 'axios';
import { API_URL } from '../lib/config';

export interface ContactPayload {
  first_name: string;
  last_name: string;
  email: string;
  subject: string;
  message: string;
}

export interface ContactResponse {
  message: string;
}

class ContactService {
  async send(payload: ContactPayload): Promise<ContactResponse> {
    const response = await axios.post<ContactResponse>(
      `${API_URL}/api/v1/contact`,
      payload,
      { headers: { 'Content-Type': 'application/json' } },
    );
    return response.data;
  }
}

export default new ContactService();
